import {AxiosPromise} from "axios";

import {eatClubClient} from "@globals/config/apiClient";
import {ObjectWithAnyProps} from "@globals/types/utilityTypes";

import {CompanyLocationsResponse} from "./types/CompanyLocations";
import {CreateUserData} from "./types/CreateUserData";

export function createUser({
  email,
  password,
  first_name,
  last_name,
  phone_number,
  delivery_location_id,
  registration_key,
  welcome_mat_slug,
  operator_slug,
}: CreateUserData): AxiosPromise<ObjectWithAnyProps> {
  return eatClubClient
    .post("/member/api/accounts/create-user/", {
      key: registration_key,
      email,
      password,
      first_name,
      last_name,
      phone_number,
      delivery_location_id,
      welcome_mat_slug,
      operator_slug,
    })
    .catch(({response, message}) => {
      const error = {
        status: response.status,
        message: response.data?.message || message,
      };
      throw error;
    });
}

export function getCompanyLocations(
  welcomeMatSlug: string,
  operatorSlug: string
): Promise<CompanyLocationsResponse> {
  return eatClubClient
    .get(`/accounts/company-locations/${operatorSlug}/${welcomeMatSlug}`)
    .then((response) => response.data)
    .catch(({response}) => {
      const err = {
        status: response.status,
        message: response.data?.message || response.data,
      };
      throw err;
    });
}
